import React from 'react';

const DashboardStats = ({ transactions = [] }: any) => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const currentDay = now.getDate();
  const currentQuarter = Math.floor(currentMonth / 3);

  let sumToday = 0, sumMonth = 0, sumQuarter = 0, sumYear = 0;

  transactions.forEach((t: any) => {
    if (t.status !== 'paid' && t.status !== 'success') return;
    const date = t.date ? new Date(t.date) : null;
    if (!date) return;
    const amount = t.amount || 0;

    if (date.getFullYear() === currentYear) {
      sumYear += amount;
      if (Math.floor(date.getMonth() / 3) === currentQuarter) sumQuarter += amount;
      if (date.getMonth() === currentMonth) {
        sumMonth += amount;
        if (date.getDate() === currentDay) sumToday += amount;
      }
    }
  });

  const fmt = (n: number) => n.toLocaleString('ru-RU') + ' ₽';

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
      <div style={{ background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', padding: 24, borderRadius: 20, border: '1px solid #bfdbfe' }}>
        <div style={{ color: '#1e40af', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>За текущий год</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#1e3a8a' }}>{fmt(sumYear)}</div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #f5f3ff, #ede9fe)', padding: 24, borderRadius: 20, border: '1px solid #ddd6fe' }}>
        <div style={{ color: '#6b21a8', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>За квартал</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#4c1d95' }}>{fmt(sumQuarter)}</div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', padding: 24, borderRadius: 20, border: '1px solid #a7f3d0' }}>
        <div style={{ color: '#047857', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>За месяц</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#064e3b' }}>{fmt(sumMonth)}</div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #fff7ed, #ffedd5)', padding: 24, borderRadius: 20, border: '1px solid #fed7aa' }}>
        <div style={{ color: '#c2410c', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>За сегодня</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#7c2d12' }}>{fmt(sumToday)}</div>
      </div>
    </div>
  );
};

export default DashboardStats;
